import { render, staticRenderFns } from "./environmentalReport.vue?vue&type=template&id=c6a0a624"
import script from "./environmentalReport.vue?vue&type=script&lang=js"
export * from "./environmentalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports